import { render } from "./PattyThreadList.vue?vue&type=template&id=ea12485c&scoped=true"
import script from "./PattyThreadList.vue?vue&type=script&lang=js"
export * from "./PattyThreadList.vue?vue&type=script&lang=js"

import "./PattyThreadList.vue?vue&type=style&index=0&id=ea12485c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea12485c"]])

export default __exports__